<template>
  <div class="viewDiv">
    <div class="viewDiv" id="viewDiv">
    </div>
    <v-overlay :value="loading" color="blue-grey darken-3" opacity="0.6">
      <v-progress-circular
        indeterminate
        size="64"
        color="blue-grey lighten-4"
      ></v-progress-circular>
    </v-overlay>
 <v-menu
      transition="slide-x-transition"
      v-model="contextMenuModel"
      :position-x="contextMenuX"
      :position-y="contextMenuY"
      absolute
      offset-y
    >
      <v-list dense>
        <v-list-item @click="contextMenuItemClick('streetview')">
          <v-list-item-icon class="mr-2"><v-icon>mdi-google</v-icon></v-list-item-icon>
          <v-list-item-title>Google Street View</v-list-item-title>
        </v-list-item>
        <v-list-item @click="contextMenuItemClick('mb')">
          <v-list-item-icon class="mr-2"><v-icon>mdi-map-marker-radius</v-icon></v-list-item-icon>
          <v-list-item-title>Mapping Browser</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog
      v-model="debugDialog"
      persistent
      width="500"
    >
      <v-card>
        <v-card-title class="subtitle-1 font-weight-light pink lighten-1 white--text">
          <v-icon class="mr-2">mdi-bug</v-icon> Routes to Schools 0.2.0
        </v-card-title>
        <v-card-text class="mt-4">

          <p class="pink--text">This application has been updated due to the graphical issues experienced when changing schools and zooming. 
            Could you please test this update and report any issues. </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="pink"
            text
            @click="debugDialog = false"
          >
            Got it!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  
<div class="infoContainer">    
  <v-expansion-panels multiple v-model="infoPanelModel" style="width: 300px;" >
      <v-expansion-panel >
        <v-expansion-panel-header dense flat class="font-weight-regular subtitle-1 blue-grey lighten-5 pl-0 pr-2 pb-1 pt-1"><v-icon class="mr-0">mdi-routes</v-icon>
        <span class="subtitle-2 font-weight-light">{{`Routes to Schools: ${(Number(Math.round(((startRouteDistance + routeDistance + endRouteDistance)*routeUnitsModel.multiplier)+'e'+3)+'e-'+3))} ${routeUnitsModel.unit}`}}</span>
      </v-expansion-panel-header>
      <v-expansion-panel-content  >
<v-container class="pa-0 mt-2">
    <v-row dense >
      <v-col cols="12">
        <v-card :color="startColour" dark>
            <!-- <v-card-subtitle>Start</v-card-subtitle> -->
            <v-card-text class="caption">
              {{startPointText}}
            </v-card-text>
            <v-card-actions class="pa-0"><v-spacer></v-spacer>
              <v-btn icon v-show="startPointGraphic" @click="zoom('start')" ><v-icon small>mdi-magnify</v-icon></v-btn>
            </v-card-actions>
          </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-card :color="endColour" dark>
            <!-- <v-card-subtitle>End</v-card-subtitle> -->
            <v-card-text class="caption">
              {{endPointText}}
            </v-card-text>
            <v-select hide-details style="font-size:12px" 
             v-show="endPointGraphics.length>1" dense class="mx-4 pb-4" 
             :items="endPointGraphics" @change="selectedEndPointChange" v-model="selectedEndPointModel"
          ></v-select>
              <v-card-actions class="pa-0"><v-spacer></v-spacer>
              <v-btn icon v-show="endPointGraphic" @click="zoom('end')" ><v-icon small>mdi-magnify</v-icon></v-btn>
            </v-card-actions>
          </v-card>
      </v-col>
    </v-row>
        <v-row dense>
      <v-col cols="12">
        <v-card color="#385F73" dark>
            <v-card-text class="caption">
              <div class="white--text subtitle-2" v-show="routeDistance"  >{{`Route Distance: ${(Number(Math.round(((startRouteDistance + routeDistance + endRouteDistance)*routeUnitsModel.multiplier)+'e'+3)+'e-'+3))} ${routeUnitsModel.unit}`}}</div>  
              <!-- <div v-show="routeDistance"  >{{`Network Distance: ${(Number(Math.round((routeDistance*routeUnitsModel.multiplier)+'e'+3)+'e-'+3))} ${routeUnitsModel.unit}`}}</div> -->
              <div v-show="routeDistance"  >{{`Point to Point Distance: ${(Number(Math.round((crowDistance*routeUnitsModel.multiplier)+'e'+3)+'e-'+3))} ${routeUnitsModel.unit}`}}</div>
            </v-card-text>
            <v-card-actions class="pa-0">              
              <v-spacer></v-spacer>
              <v-btn icon v-show="lastRouteGraphic" @click="zoom('route')"><v-icon small>mdi-magnify</v-icon></v-btn>
            </v-card-actions>
          </v-card>           
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="caption blue-grey--text">
        <div class="float-right pr-2">{{settingsText}}</div>
      </v-col>
    </v-row>
    <v-row >
      <v-col cols="12" >
        <v-btn elevation="2" class="mr-2 mt-2" icon><v-icon>mdi-autorenew</v-icon></v-btn>
        <v-btn elevation="2" class="mr-2 mt-2" icon @click.stop="printScreen"><v-icon>mdi-printer</v-icon></v-btn>
        <div class="float-right">
          <v-btn elevation="2" class="mr-2 mt-2" icon @click.stop="layersDialogModel=true"><v-icon>mdi-layers</v-icon></v-btn>
          <v-btn elevation="2" class="mr-2 mt-2" icon @click.stop="basemapsDialogModel=true"><v-icon>mdi-earth</v-icon></v-btn>          
          <v-btn elevation="2" class="mr-2 mt-2" icon  @click.stop="settingsDialogModel = true"><v-icon>mdi-cog</v-icon></v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>   
  </v-expansion-panels>
</div> 
    <v-dialog v-model="settingsDialogModel" max-width="300" scrollable persistent>
      <v-card>
      <v-card-title class="font-weight-regular subtitle-1 blue-grey lighten-5">
          <v-icon class="mr-2">mdi-cog</v-icon> Settings
      </v-card-title>
      <v-card-text >
        <v-container fluid>
          <v-row>
            <v-select v-model="routeUnitsModel" :items="routeUnits"></v-select>
          </v-row>
         
          <v-row>
            <v-select return-object item-text="text" item-value="id" @change="networkChange" v-model="routeNetworksModel" :items="networks"></v-select>
          </v-row>
           <v-row>
            <v-switch @change="restrictionsChange" v-model="networkRestrictionsModel"
              inset
              label="Network Restrictions"
            ></v-switch>
          </v-row>
        </v-container>
      </v-card-text> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="settingsDialogModel = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="layersDialogModel" max-width="400" scrollable persistent>
      <v-card>
        <v-card-title class="font-weight-regular subtitle-1 blue-grey lighten-5">
            <v-icon class="mr-2">mdi-layers</v-icon> Layers
        </v-card-title>
        <v-card-text class="pa-2" style="height: 280px;">
          <v-list dense>
            <v-list-item-group  color="blue darken-1">
              <v-list-item v-for="(item, i) in this.layers" :key="i">
                <v-list-item-action>
                  <v-checkbox 
                  v-model="selectedLayersModel" 
                  color="primary" 
                  :value="item.id" 
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                <v-list-item-title v-html="item.title"></v-list-item-title>
                </v-list-item-content>

              </v-list-item>
            </v-list-item-group>
          </v-list>
      </v-card-text> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="layersDialogModel = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Backdrops -->
    <v-dialog v-model="basemapsDialogModel" max-width="340" scrollable persistent>
      <v-card>
        <v-card-title class="font-weight-regular subtitle-1 blue-grey lighten-5">
           <v-icon class="mr-2">mdi-earth</v-icon> Backdrops
        </v-card-title>
        <v-card-text class="pt-2" style="height: 160px;">
          <v-radio-group v-model="selectedBasemapModel">
    
          <v-radio
            v-for="(item, i) in this.basemaps" :key="i"
            :label="item.title"
            :value="item.id"
          ></v-radio>
        </v-radio-group>
      </v-card-text> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="basemapsDialogModel = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Address Search -->
    <v-dialog v-model="addressSearchDialogModel" max-width="400" scrollable persistent>
      <v-card class="mx-auto">
      <v-card-title >
          <v-text-field v-model="addressSearchTextModel" prepend-icon="mdi-home" :loading="addressSearchLoading" label="Address Search"></v-text-field>
      </v-card-title> 
      <v-card-text style="height: 300px;">        
          <v-list dense>
            <v-list-item-group v-model="addressSearchModel" color="blue darken-1">
              <v-list-item v-for="(item, i) in addressSearchResults" :key="i">
                <v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title v-html="item.ADDRESS"></v-list-item-title>
                    <v-list-item-subtitle v-html="item.UPRN"></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
      </v-card-text> 
        <v-card-actions>
          <span class="pl-2 caption">{{addressSearchResults.length > 0 ?  addressSearchResults.length == 1 ? '1 address' : `${addressSearchResults.length} addresses` : ''}}</span>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="addressSearchDialogModel = false;addressSearchMode=null;">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="selectAddress">Select</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--School Selector -->
    <v-dialog v-model="schoolsDialogModel" width="400" max-width="400" scrollable persistent>
      <v-card>       
        <v-card-title >
          <v-select :items="schoolCategoryList" v-model="schoolCategoryModel"></v-select>
          <v-text-field label="Filter" dense v-model="schoolFilterTextModel"></v-text-field>
        </v-card-title>                
        <v-card-text style="height: 300px;">
          <v-list dense>
            <v-list-item-group v-model="schoolModel">
              <v-list-item v-for="(item, i) in schoolEntranceListFiltered" :key="i">
                <v-list-item-content>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                  <v-list-item-subtitle>{{`${item.distance} ${routeUnitsModel.unit}`}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-badge color="blue-grey lighten-1" v-if="item.alternativeEntrances.length" :content="item.alternativeEntrances.length"></v-badge>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text> 
        <v-card-actions>
          <v-btn-toggle v-model="schoolSortModel">
            <v-btn @click="schoolSort(false)" small>
              <v-icon>mdi-sort-alphabetical-ascending</v-icon>
            </v-btn>
            <v-btn @click="schoolSort(true)" small >
              <v-icon>mdi-sort-clock-ascending</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="schoolsDialogModel = false">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="selectSchool();">Select</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--School Selector -->    
  <!--Buttons -->
  <div class="buttonsContainer">
    <v-container >
      <!--Start Buttons -->
      <v-row dense>
        <v-col>
          <v-speed-dial  v-model="showStartSpeedDial" direction="right" transition="slide-x-transition">
            <template v-slot:activator>
              <v-btn v-model="showStartSpeedDial" :color="startColour" dark fab>
                  <v-icon v-if="showStartSpeedDial">mdi-home</v-icon>
                  <v-icon v-else>mdi-home</v-icon>
              </v-btn>
            </template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="userAddPoint('start',startColour)" fab dark small :color="startColour">
                  <v-icon>mdi-map-marker</v-icon>
                </v-btn>
              </template>
              <span>Add Start Point</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click.stop="disableMapClick();chooseAddress('start')" fab dark small :color="startColour">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Search Address</span>
            </v-tooltip>
          </v-speed-dial>
        </v-col>
      </v-row>
      <!--Start Buttons -->
      <!--End Buttons -->
      <v-row dense style="height:64px" >
        <v-col >
          <template>
          <v-speed-dial v-show="schoolCatchmentComplete" v-model="showEndSpeedDial"  direction="right" transition="slide-x-transition">
            <template v-slot:activator>
              <v-btn v-model="showEndSpeedDial" :color="endColour" dark fab>
                  <v-icon v-if="showEndSpeedDial">mdi-school</v-icon>
                  <v-icon v-else>mdi-school</v-icon>
              </v-btn>
            </template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="userAddPoint('end',endColour)" fab dark small :color="endColour">
                  <v-icon>mdi-map-marker</v-icon>
                </v-btn>
              </template>
              <span>Add End Point</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click.stop="disableMapClick();chooseAddress('end')" fab dark small :color="endColour">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Search Address</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click.stop="disableMapClick();schoolsDialogModel = true" fab dark small :color="endColour">
                  <v-icon>mdi-school</v-icon>
                </v-btn>
              </template>
              <span>Search Schools</span>
            </v-tooltip>
          </v-speed-dial>
          </template>
        </v-col>
      </v-row>
      <!--End Buttons -->
      <!--Stop Buttons -->
      <v-row dense style="height:64px" >
        <v-col>
        <v-badge :color="stopColour" bottom bordered overlap :value="stops.length" :content="stops.length">  
          <v-speed-dial v-show="schoolCatchmentComplete"  v-model="showStopSpeedDial" direction="right" transition="slide-x-transition">
            <template v-slot:activator>
              <v-btn v-model="showStopSpeedDial" :color="stopColour" dark fab>
                  <v-icon v-if="showStopSpeedDial">mdi-stop</v-icon>
                  <v-icon v-else>mdi-stop</v-icon>
              </v-btn>
            </template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="userAddPoint('stop',stopColour)" fab dark small :color="stopColour">
                  <v-icon>mdi-map-marker</v-icon>
                </v-btn>
              </template>
              <span>Add stop</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="undoStop()" fab dark small :color="stopColour">
                  <v-icon>mdi-undo</v-icon>
                </v-btn>
              </template>
              <span>Undo stop</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="clearStops()" fab dark small :color="stopColour">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Clear stops</span>
            </v-tooltip>
          </v-speed-dial>
        </v-badge>
        </v-col>
      </v-row>
      <!--Stop Buttons -->
      <v-row dense style="height:64px" >
        <v-col>
        <v-badge :color="barrierColour" bottom bordered overlap :value="barriers.length" :content="barriers.length">
          <v-speed-dial v-show="schoolCatchmentComplete"  v-model="showBarrierSpeedDial" direction="right" transition="slide-x-transition">
            <template v-slot:activator>
              <v-btn v-model="showBarrierSpeedDial" :color="barrierColour" dark fab>
                  <v-icon v-if="showBarrierSpeedDial">mdi-sign-caution</v-icon>
                  <v-icon v-else>mdi-sign-caution</v-icon>
              </v-btn>
            </template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="userAddPoint('barrier',barrierColour)" fab dark small :color="barrierColour">
                  <v-icon>mdi-map-marker</v-icon>
                </v-btn>
              </template>
              <span>Add barrier</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="undoBarrier()" fab dark small :color="barrierColour">
                  <v-icon>mdi-undo</v-icon>
                </v-btn>
              </template>
              <span>Undo barrier</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="clearBarriers()" fab dark small :color="barrierColour">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Clear barriers</span>
            </v-tooltip>
          </v-speed-dial>
        </v-badge>         
        </v-col>
      </v-row>
    </v-container>
    <!--Buttons -->
  </div>
      <v-snackbar top timeout="-1"
        v-model="snackbar">
         {{ snackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn small :color="snackbarColour" v-bind="attrs" @click="snackbar = false"> Cancel</v-btn>
        </template>
      </v-snackbar>
  </div>
</template>

<script>

import { loadModules } from "esri-loader";
import axios from 'axios';
import { LocatorHub } from "../EsriLocatorHub.js";
import OsGridRef, { LatLon, Dms } from "../util/geodesy/osgridref.js";
import { OSPlaces } from "../OSPlaces.js";
export default {
  props: {
    basemaps: {
      type: Array,      
      required: true
    },
    networks:{
      type: Array,
      required: true
    },
    basemapCopyright:{
      type: String,
      required: true
    },
    layerUrl: {
      type: String,
      required: true
    },
    primaryCatchmentService:{
      type: String,
      required: true
    },
    secondaryCatchmentService:{
      type: String,
      required: true
    },
    juniorCatchmentService:{
      type: String,
      required: true
    },
    msal: {
      type: Object
    },
  },
  data: () => ({

      networkService: null,
      tokenRefreshInterval: null,
      locatorHubUrl: "https://maps.norfolk.gov.uk/gazetteer",
      tokenTimeoutMins: 50,
      locatorToken: "",
      debugDialog:false,
      infoPanelModel: [0],

      //contextMenu

      contextMenuX:0,
      contextMenuY:0,
      contextMenuModel:false,
      contextMenuMapPoint:null,     

      //global

      loading:false,

      esriRouteParameters: null,
      esriMap:null,
      esriTileLayer: null,
      esriBasemap: null,
      esriFeatureLayer:null,
      esriMapView: null,
      esriWatchUtils: null,
      esriGraphic:null,
      esriFeatureSet:null,
      esriGeometryEngine:null,
      esriPromiseUtils:null,
      esriQuery:null,
      esriQueryTask:null,

      mapView:null,
      sceneView:null,

      startPointGraphic:null,
      startPointText:"",
      endPointGraphic:null,
      endPointGraphics:[],
      selectedEndPointModel:null,
      endPointText:"",
      stops:[],
      barriers:[],

      showRouteButtons:false,

      lastRouteGraphic:null,

      //
      crowDistance:'',
      routeDistance:'',
      startRouteDistance:'',
      endRouteDistance:'',
      networkDistance:'',

      //

      /*Units*/
      routeUnits: [
        { text: 'Feet',  value: {multiplier: '3.2808', unit:"ft"}},
        { text: 'Metres',  value: {multiplier: '1', unit:"m"}},
        { text: 'Kilometres',  value: {multiplier: '0.001', unit:"km"}},
        { text: 'Miles',  value: {multiplier: '0.000621', unit:"mi"}},
      ],
      routeUnitsModel: { multiplier: '0.000621', unit:"mi"},

      mapImageLayer : null,
      mapImageLayerSubLayers:[],
      selectedLayersModel : [],
    
      routeNetworksModel:null,
      networkRestrictionsModel:true,

      addressSearchTextModel:"",
      addressSearchModel:null,
      addressSearchTitle:"",
      addressSearchDialogModel:null,
      addressSearchLoading: false,
      addressSearchResults:[],
      addressSearchMode:null,

      schoolCategoryList:[],
      schoolCategoryAll:'All Categories',
      schoolCategoryCatchment:'Catchment',
      schoolCategoryModel:null,
      schoolEntranceList:[],
      schoolCatchmentList:[],
      schoolCatchmentComplete:false,

      schoolFilterTextModel:"",
      schoolSortModel:0,
      schoolModel:null,
      schoolsDialog: false,
      schoolsDialogModel: null,
      settingsDialogModel:null,
      layersDialogModel:null,
      basemapsDialogModel:null,
      selectedBasemapModel:"basemap0",
      selectedSchool:null,
      blockZoom:false,

      nonRouteLineSymbol: {
        type: "simple-line",
        style: "short-dash-dot",
        width: 2.75,
        color: [159, 140, 255, 1]
      },
      routeLineSymbol: {
        type: "simple-line",
        style: "short-dash-dot",
        width: 2.75,
        color: [59, 140, 255, 1]
      },


      startColour: "#0288D1",
      endColour: "#29648a",
      stopColour: "#2b7a78",
      barrierColour: "#4b4b4b",
      undoColour: "#78909C",
      genericColour:"#546E7A",
      routeColour:"#ef37ac",

      snackbar: false,
      snackbarText: '',
      snackbarColour: null,

      showStartSpeedDial:false,
      showEndSpeedDial:false,
      showStopSpeedDial:false,
      showBarrierSpeedDial:false,


      pointMode:null,
      routeGraphicsLayer:null,
      esriRouteTask:null,      
      startPoint:null,
      endPointNull:null,


      primarySchoolCatchmentsLayer:null,
      juniorSchoolCatchmentLayer:null,
      secondarySchoolCatchmentLayer:null,

  }),
  created(){
    console.log("map: created");

    loadModules([
      "esri/Map",
      "esri/layers/TileLayer",
      "esri/layers/MapImageLayer",
      "esri/views/MapView",
      "esri/views/SceneView",
      "esri/Basemap",
      "esri/layers/FeatureLayer",
      "esri/rest/route",
      "esri/rest/support/RouteParameters",    
      "esri/Graphic",
      "esri/layers/GraphicsLayer",
      "esri/rest/support/FeatureSet",
      "esri/core/watchUtils",
      "esri/layers/support/LabelClass",
      "esri/rest/support/Query",
      "esri/rest/query",
      "esri/geometry/Point",
      "esri/geometry/geometryEngine", // async?
      "esri/core/promiseUtils"

    ]).then(
      ([
        Map,
        TileLayer,
        MapImageLayer,
        MapView,
        SceneView,
        Basemap,
        FeatureLayer,
        RouteTask,
        RouteParameters,        
        Graphic,
        GraphicsLayer,
        FeatureSet,
        watchUtils,
        LabelClass,
        Query,
        QueryTask,
        Point,
        geometryEngine,
        promiseUtils,        
      ]) => {

        this.esriMap = Map;
        this.esriTileLayer = TileLayer;
        this.esriBasemap = Basemap;
        this.esriMapView = MapView;
        this.esriFeatureLayer = FeatureLayer;
        this.esriRouteTask = RouteTask;        
        this.esriWatchUtils = watchUtils
        this.esriGraphic = Graphic;
        this.esriFeatureSet = FeatureSet;
        this.esriPoint = Point;
        this.esriQuery = Query;
        this.esriQueryTask = QueryTask;
        this.esriGeometryEngine = geometryEngine;
        this.esriPromiseUtils = promiseUtils;
        this.esriRouteParameters = RouteParameters;

        var schoolEntrancesUrl = import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/layers/ncc_etd_travel_and_transport/MapServer/11"; // Represents the REST endpoint for a layer of cities.
        var schoolEntrancesAlternativeUrl = import.meta.env.VITE_ARCGIS_URL + "/server/rest/services/layers/ncc_etd_travel_and_transport/MapServer/12";
        

        this.routeNetworksModel= this.networks[0];
      
        var query = new Query();
        query.returnGeometry = true;
        query.outFields = ["SITE_NAME,SITE_CATEG,DFE"];
        query.where = "1=1"; 
    
        this.$emit('updateLoadingInfo', "Waiting for map services ...")

        Promise.all([
          this.esriQueryTask.executeQueryJSON(schoolEntrancesUrl, query),
          this.esriQueryTask.executeQueryJSON(schoolEntrancesAlternativeUrl, query)          
        ])
          .then((results) => { 
           
            this.schoolCategoryList.push(this.schoolCategoryCatchment);
            this.schoolCategoryList.push(this.schoolCategoryAll);
            this.schoolCategoryModel=this.schoolCategoryAll;

            for (let i=0, l=results[0].features.length; i<l; i++)
            {  

              if (this.schoolCategoryList.indexOf(results[0].features[i].attributes.SITE_CATEG) === -1 && results[0].features[i].attributes.SITE_CATEG !== '')
              this.schoolCategoryList.push(results[0].features[i].attributes.SITE_CATEG);

              this.schoolEntranceList.push({
                name:results[0].features[i].attributes.SITE_NAME,
                dfe:results[0].features[i].attributes.DFE,
                category:results[0].features[i].attributes.SITE_CATEG,
                geometry:results[0].features[i].geometry,
                catchment:false,
                distance:null,
                alternativeEntrances:results[1].features.filter(f=>f.attributes.DfE==results[0].features[i].attributes.DFE && f.attributes.DfE!==null)
              })
            }
            this.schoolCategoryList.sort();
            this.schoolEntranceList.sort((a, b) => a.name.localeCompare(b.name));

           


            //route setup
            this.routeGraphicsLayer = new GraphicsLayer({id:"routeGraphicsLayer", title:"Route Graphics Layer"});                 

          this.mapImageLayer = new MapImageLayer({
            url: this.layerUrl,
          })

          let baseLayers = [];
          
          this.basemaps.forEach(basemap => {
            baseLayers.push(
              new TileLayer({ 
                id:basemap.id,
                url: basemap.url,
                visible: basemap.visible,
                title: basemap.title,
                copyright: basemap.copyright
              })  
            );            
          });

          const basemap = new Basemap({baseLayers:baseLayers});
          
          var map = new Map({
            basemap: basemap,      
            layers: [
              this.routeGraphicsLayer, 
              this.mapImageLayer,
            ]
          });

          const viewParams ={
            map:map,
            // center: [619747.4685000004,308348.8496000003],
            // zoom:13,
            //camera: {
            //  position:{
            //    x: 622491.8405865959,
            //    y: 307322.0082926142,
            //    z: 2163.7093836705715
            //  },
            //  heading: 180,
            //  tilt: 39
            //},
            container: "viewDiv",
            ui: {components: []},
            center: [622877,320142],
            zoom: 1
          }


          this.mapView = new MapView(viewParams);          

          this.mapView.on("click", this.mapClick);     

          this.mapView.when(async ()=>{
            console.log("when");

          /*  this.locatorToken = await this.getLocatorHubToken();
            this.tokenRefreshInverval = setInterval(async () => {
              this.locatorToken = await this.getLocatorHubToken();
            }, this.tokenTimeoutMins * 1000 * 60)*/

            this.mapImageLayerSubLayers = this.mapImageLayer.allSublayers.items;

            let target = {
              type: "point", // autocasts as new Point()
              x: 622877,
              y: 320142,
              spatialReference: {wkid:27700}
            }
            this.mapView.center = target;
            
            setTimeout(()=>{
              const loader = document.getElementById("load-wrapper");
              loader.style.opacity='0';
              loader.style.visibility='hidden';  
            }, 3000);                        
          });
        })
        .catch((e) => { 
          console.log(e) 
        });
    })
  },
  computed:{

    networkItems() {
      return this.networks.map(network => {
        return {
          text: network.text,
          value: network,
          disabled: false
        }
      })
    },

    layers(){
      return this.mapImageLayerSubLayers.filter(item=>!item.title.includes('Entrance'))
    },
    schoolEntranceListFiltered(){

      if(this.schoolCategoryModel==this.schoolCategoryAll)
        return this.schoolEntranceList.filter(school=> {
          return school.name.toLowerCase().includes(this.schoolFilterTextModel.toLowerCase())
        });
      else if(this.schoolCategoryModel==this.schoolCategoryCatchment)
      {
        return this.schoolEntranceList
        .filter(
          school => this.schoolCatchmentList.includes(school.dfe)
        )
        .filter(school=> {
          return school.name.toLowerCase().includes(this.schoolFilterTextModel.toLowerCase())
        });
      }
      else
        return this.schoolEntranceList.filter(school => {
          return school.category == this.schoolCategoryModel
        }).filter(school=> {
          return school.name.toLowerCase().includes(this.schoolFilterTextModel.toLowerCase())
        });
    },
    settingsText(){  

      if (this.routeNetworksModel) {
        return `${this.routeNetworksModel.text} ${this.networkRestrictionsModel ? "(Restrictions)":""}`;
      }
    }
  },
  watch:{
    routeNetworksModel() {
      this.seletedNetworkItem
    },
    selectedBasemapModel(value){
      this.mapView.map.basemap.baseLayers.items.forEach((baselayer,i)=>{
        baselayer.visible = baselayer.id===value;
      });
    },
    selectedLayersModel(value){
      this.mapImageLayer.allSublayers.forEach((sublayer,i)=>{
        sublayer.visible = (value.includes(sublayer.id) ? true : false) 
      });
    },
   
    schoolsDialogModel(value){
      if(value){ 
        if(this.startPointGraphic!=null){
         
          for (var school of this.schoolEntranceList) {
            const distance = this.esriGeometryEngine.distance(this.startPointGraphic.geometry,school.geometry);
            school.distance = Number(Math.round((distance*this.routeUnitsModel.multiplier)+'e'+2)+'e-'+2);
          }
        }
      }
    },
    async addressSearchTextModel(value) {  
      if(value.length<3) return; //more than 3 characters please.
      this.addressSearchLoading=true;   
      this.addressSearchResults=[];   
      let os = new OSPlaces(import.meta.env.VITE_OS_PLACES_URL, this.msal, import.meta.env.VITE_MBAPI_AppIDURI);
      let results;

      try {

        results = await os.find(value, ["NCC"], null, true);        

      } catch (e) {
        let error = new Error("Could not perform OS search.  Server maybe unavailable.");
        error.message = e.message;
        throw error;
      }

      let addresses = results.map(result => result.NCC);    
      
      // filter out...      
      addresses = addresses.filter(x => !x.CLASSIFICATION_CODE.startsWith("LW")) // Water features (e.g. named ponds)      
      
      this.addressSearchResults=addresses;      
      this.addressSearchLoading=false;      
    },
  },
  methods:{

    async getLocatorHubToken() {

      let u = "routestoschools"
      let p = "f0j7z81ov4d$t"

      let query = this.locatorHubUrl + "/GetToken" + `?username=${u}&password=${p}&format=json`      
      let result = await axios.get(query);
      return result.data;
    },

    // returns a new image created by adding a custom text to the webscene image
    getImageWithText(screenshot, text) {
      const imageData = screenshot.data;

      // to add the text to the screenshot we create a new canvas element
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.height = imageData.height;
      canvas.width = imageData.width;

      // add the screenshot data to the canvas
      context.putImageData(imageData, 0, 0);
      context.font = "12px Arial";
      context.fillStyle = "#000";
      context.fillRect(0, imageData.height - 40, context.measureText(text).width + 20, 30);

      // add the text from the textInput element
      context.fillStyle = "#fff";
      context.fillText(text, 10, imageData.height - 20);

      return canvas.toDataURL();
    },

    printScreen(){

      console.log("PrintScreen");
      const text = this.basemapCopyright;

      this.mapView.takeScreenshot({ format: "png" }).then((screenshot)=> {
        
        const dataUrl = this.getImageWithText(screenshot, text);        
        
        const filename = "test.png"
        const element = document.createElement("a");
        element.setAttribute("href", dataUrl);
        element.setAttribute("download", filename);
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);    
      });
      
    },
    selectedEndPointChange(value){
      console.log("method.selectedEndPointModel");
      //console.log(value);
      if(value!==0)this.blockZoom=true;
      if(value!==undefined || value!==null){
        this.addStop(this.endPointGraphics[value]); //primary
      }
    },
    networkChange(){
      console.log("method.networkChange");

      if(this.startPointGraphic !== null && this.endPointGraphic !==null)
        this.solveRoute();
    },
    restrictionsChange(value){
      console.log("method.restrictionsChange");
      console.log(value);      
      if(this.startPointGraphic !== null && this.endPointGraphic !==null)
        this.solveRoute();
    },
    zoom(location){
      switch(location){
        case "start":
          this.mapView.goTo({target: this.startPointGraphic.geometry, zoom:8})
          break;
        case "end":
          this.mapView.goTo({target: this.endPointGraphic.geometry, zoom:8})
          break;
          case "route":
          this.mapView.goTo({target: this.routeGraphicsLayer.graphics})
          break;
      }
    },
    schoolSort (byDistance) {
      if(byDistance)
        this.schoolEntranceList.sort((a, b) => a.distance - b.distance);
      else
        this.schoolEntranceList.sort((a, b) => a.name.localeCompare(b.name));
    },

    showSnackbar(message,colour){
      this.snackbarColour=colour;
      this.snackbarText=message;
      this.snackbar=true;
    },
    userAddPoint(pointMode,colour){
      this.showSnackbar(`Click the map to add a ${pointMode} point`, colour);
      this.pointMode=pointMode;
    },
    showRoute(data) {

      console.log("showRoute", this.routeGraphicsLayer.graphics.length);
      //ROUTE
      if(this.lastRouteGraphic!==null) this.routeGraphicsLayer.remove(this.lastRouteGraphic);
      this.lastRouteGraphic = data.routeResults[0].route;
      this.lastRouteGraphic.symbol=this.routeLineSymbol;
      this.routeGraphicsLayer.add(this.lastRouteGraphic);
      this.lastRoute = data.routeResults[0].route;

      //START LINE
      const routeStartPoint = this.lastRoute.geometry.getPoint(0,0);
      if (routeStartPoint) {
        const startPolyline = {
          type: "polyline", 
          paths: [[routeStartPoint.x,routeStartPoint.y], [this.startPointGraphic.geometry.x,this.startPointGraphic.geometry.y]],
          spatialReference: {wkid:27700}
        };
        this.routeGraphicsLayer.add(
          new this.esriGraphic({
            geometry: startPolyline, 
            symbol: this.nonRouteLineSymbol, 
          })
        );
        
        //END LINE
        const routeEndPoint = this.lastRoute.geometry.getPoint(this.lastRoute.geometry.paths.length-1,this.lastRoute.geometry.paths[this.lastRoute.geometry.paths.length-1].length-1);
        const endPolyline = {
          type: "polyline", 
          paths: [[routeEndPoint.x,routeEndPoint.y], [this.endPointGraphic.geometry.x,this.endPointGraphic.geometry.y]],
          spatialReference: {wkid:27700}
        };
        this.routeGraphicsLayer.add(
          new this.esriGraphic({
            geometry: endPolyline, 
            symbol: this.nonRouteLineSymbol, 
          })
        );

        console.log(this.blockZoom);
        if(this.blockZoom===false)
          this.mapView.goTo(this.routeGraphicsLayer.graphics);
        else
          this.mapView.goTo(routeEndPoint);

        //ZOOM OUT ONE HERE

        this.routeDistance = this.lastRouteGraphic.attributes.Total_Length;
        this.startRouteDistance = this.esriGeometryEngine.distance(routeStartPoint,this.startPointGraphic.geometry);
        this.endRouteDistance= this.esriGeometryEngine.distance(routeEndPoint,this.endPointGraphic.geometry);
        this.crowDistance = this.esriGeometryEngine.distance(this.startPointGraphic.geometry, this.endPointGraphic.geometry)

        this.renderPointsA();
      }
      this.blockZoom=false;
      this.loading = false;

    },
    solveRoute(){    
      
      this.routeGraphicsLayer.removeAll();

      let routeParams = new this.esriRouteParameters({        
        barriers: new this.esriFeatureSet(),        
        accumulateAttributes: ["Length"],
        impedanceAttribute: "Length",     
        //---------------------------------------------
        //Previous application settings, Do not change.
        outSpatialReference: {
          wkid: 27700
        },              
      });       
      
      routeParams.stops = new this.esriFeatureSet();
      routeParams.pointBarriers = new this.esriFeatureSet(); //use Point Barriers?

      if(this.startPointGraphic !== null && this.endPointGraphic !== null) {
                
        routeParams.stops.features.push(this.startPointGraphic);
        for (const graphic of this.stops) {
          routeParams.stops.features.push(graphic);
        }

        for (const graphic of this.stops) {      
          routeParams.stops.features.push(graphic);
        }

        for (const graphic of this.barriers) {
          routeParams.pointBarriers.features.push(graphic);
        }
        
        routeParams.stops.features.push(this.endPointGraphic);
        
        this.loading = true;
        
        if (this.networkRestrictionsModel && this.routeNetworksModel.id === 'roads') {   
          routeParams.restrictionAttributes = ["Inferred_Turn_Restrictions", "OneWay", "Turn_Restrictions", "routeHierarchy_Restriction"];
        }               

        routeParams.useHierarchy = false 

        try {
          this.esriRouteTask.solve(this.routeNetworksModel.value, routeParams).then(this.showRoute);
        } finally {
          this.loading = false;
        }
      }
      else{
        this.renderPointsA();
      }      
    },

    renderPointsA(){

      console.log("renderPointsA", this.routeGraphicsLayer.graphics.length);

      if(this.endPointGraphics && this.endPointGraphics.length) //alternate addresses exist.
      {
        console.log("Alternate addresses exist!");        

        for (let i = 1; i < this.endPointGraphics.length; i++) {
          this.routeGraphicsLayer.add({
            geometry: this.endPointGraphics[i].geometry,
            symbol: { 
              type: "picture-marker",
              url: new URL(`/assets/end_alt_${i}.png`, import.meta.url).href,              
              width: 24,
              height: 24,
              yoffset: 12
            }
          });
        }

        this.routeGraphicsLayer.add({
            geometry: this.endPointGraphics[0].geometry,
            symbol: { 
              type: "picture-marker",
              url: new URL(`/assets/end.png`, import.meta.url).href,                            
              width: 24,
              height: 24,
              yoffset: 12
            }
        });

      }
      else{
        //endPoint
        if(this.endPointGraphic!==null)this.routeGraphicsLayer.add(this.endPointGraphic);
      }
      //homepoint
      if(this.startPointGraphic!==null)this.routeGraphicsLayer.add(this.startPointGraphic);

      //stops
      for (const graphic of this.stops) {
        this.routeGraphicsLayer.add(graphic);
      }

      //barriers
      for (const graphic of this.barriers) {
        this.routeGraphicsLayer.add(graphic);
      }     
    },
    clearAll(){
      this.routeGraphicsLayer.removeAll();
      this.startPointGraphic = null;
      this.endPointGraphic = null;
      this.barriers = [];
      this.stops = [];
    },
    undoBarrier(){
      if (this.barriers && this.barriers.length)
      {
        this.barriers.pop();
        this.solveRoute();
      }
    },
    clearBarriers(){
      if (this.barriers && this.barriers.length)
      {
        this.barriers = [];
        this.solveRoute();
      }
    },
    undoStop(){
      if (this.stops && this.stops.length)
      {
        this.stops.pop();
        this.solveRoute();
      }
    },
    clearStops(){
      if (this.stops && this.stops.length)
      {
        this.stops = [];
        this.solveRoute();
      }
    },
    addAddress(){

    },
    async getCatchmentSchools(geometry){
      
      this.schoolCatchmentComplete=false;
      this.schoolCatchmentList=[];
      
      var query = new this.esriQuery();
      query.geometry = geometry; 
      query.returnGeometry = true;
      query.outFields = ["DfES1,DfES2,DfES3,DfES4"];
      query.spatialRelationship = "within"

      Promise.all([
        this.esriQueryTask.executeQueryJSON(this.primaryCatchmentService, query),
        this.esriQueryTask.executeQueryJSON(this.juniorCatchmentService, query),
        this.esriQueryTask.executeQueryJSON(this.secondaryCatchmentService, query),
      ])
      .then((results) => {
        //console.log(results);
        //each catchment can have UP TO 4 schools (dfes1-4). You WILL forget this.
        results.forEach(item => {
          if (Array.isArray(item.features) && item.features.length) {
              for (let dfesIndex = 1; dfesIndex < 5; dfesIndex++) {
                const attribute = `DfES${dfesIndex}`;
                if ((item.features[0].attributes[attribute]) && (item.features[0].attributes[attribute].trim()!='')) 
                  this.schoolCatchmentList.push(parseInt(item.features[0].attributes[attribute]));
              }
          }
        });
        this.schoolCatchmentComplete=true;
        this.loading = false;
      }) 
      .catch((e) => { 
        console.log(e) 
      });
    },
    addStop(stop){
      console.log("method.addStop")      

      //create graphic
      const stopGraphic = new this.esriGraphic({
        geometry: stop.geometry,
        symbol: { 
          type: "picture-marker",
          url: new URL(`/assets/${stop.type}.png`, import.meta.url).href,
          width: 24,
          height: 24,
          yoffset: 12
        }
      });

      //store graphic
      switch(stop.type){
        case "start":
          this.loading = true;
          this.startPointGraphic = stopGraphic;
          this.startPointText=stop.info;
          this.getCatchmentSchools(stopGraphic.geometry);  
          break;
        case "stop":
          this.stops.push(stopGraphic);
          break;
        case "barrier":
          this.barriers.push(stopGraphic);
          break;
        case "end":
          //end caller renders this bit
          this.endPointGraphic = stopGraphic;
          this.endPointText=stop.info;
          break;
      
      }
      //this.pointMode=null;
      this.solveRoute();
    },
    selectAddress(){
      if(this.addressSearchModel!= null)
      {
          let stop = {
            info:this.addressSearchResults[this.addressSearchModel].ADDRESS,
            type: this.addressSearchMode,
            geometry: {
              type: "point", 
              x: this.addressSearchResults[this.addressSearchModel].X_COORDINATE,
              y: this.addressSearchResults[this.addressSearchModel].Y_COORDINATE,
              spatialReference: {wkid:27700}
            }
          }
          this.addressSearchDialogModel=false;
          this.addStop(stop);
      }
      else{
        console.log("error", this.addressSearchModel)
      }
    },
    chooseAddress(mode){
      switch(mode){
        case "start":
          this.addressSearchMode="start";
          break;
        case "end":
          this.addressSearchMode="end";
          break;
      }
      this.addressSearchDialogModel=true;
    },
    
    selectSchool(){
      
      console.log("method.selectSchool");
      console.log(this.schoolModel);
      if(this.schoolModel===undefined||this.schoolModel===null)return;


      this.clearEndPoint();
      this.schoolsDialogModel = false;
      //add primary endpoint stop
      
      this.endPointGraphics=[
        {
          text:"Primary Entrance",
          value:0,
          info: `${this.schoolEntranceListFiltered[this.schoolModel].name}`,
          type: "end",
          geometry: this.createPoint(this.schoolEntranceListFiltered[this.schoolModel].geometry.x,this.schoolEntranceListFiltered[this.schoolModel].geometry.y)
        }
      ];


      for (let i = 0; i < this.schoolEntranceListFiltered[this.schoolModel].alternativeEntrances.length; i++) {
        this.endPointGraphics.push({
          text:`Alt Entrance ${i+1}`,
          value:i+1,
          info: `${this.schoolEntranceListFiltered[this.schoolModel].name}`,
          type: "end",
          geometry: this.schoolEntranceListFiltered[this.schoolModel].alternativeEntrances[i].geometry
        }); 
      }
      this.selectedEndPointModel=0;
      this.selectedEndPointChange(0);     
    },

    createPoint(x,y){
      return {
        type: "point", 
        x: x,
        y: y,
        spatialReference: {wkid:27700}
      }
    },

    disableMapClick(){
      this.snackbar=false;
      this.pointMode=null;
    },


    contextMenuItemClick(where){

      if (where === 'streetview') {
        const gridref = new OsGridRef(this.contextMenuMapPoint.x, this.contextMenuMapPoint.y);
        const pWgs84 = gridref.toLatLon();
        window.open(`https://www.google.com/maps?ie=UTF8&layer=c&cbll=${pWgs84._lat},${pWgs84._lon}&cbp=1,0,,0,5&ll=${pWgs84._lat},${pWgs84._lon}`, '_blank');
      } else if (where === 'mb') {      
        window.open(`https://mb.norfolk.gov.uk/?x=${this.contextMenuMapPoint.x}&y=${this.contextMenuMapPoint.y}`, '_blank');
      }
    },

    mapClick(e){
      this.snackbar=false;

      //right click
      if(e.button===2)
      {
        this.contextMenuModel = false;
        this.contextMenuX = e.screenPoint.x
        this.contextMenuY = e.screenPoint.y
        this.$nextTick(() => {
          this.contextMenuModel = true;
          this.contextMenuMapPoint = e.mapPoint;
        })
        return;
      }

      //left click
      if (this.pointMode===null) return;
      
      if (this.pointMode==="end") {
        this.endPointGraphics=[];
        this.selectedSchool=null;
      }

      //create stop object
      let stop = {
        info:`${(Number(Math.round(e.mapPoint.x+'e'+2)+'e-'+2))}, ${(Number(Math.round(e.mapPoint.y+'e'+2)+'e-'+2))}`,
        type: this.pointMode,
        geometry: e.mapPoint
      }
      this.pointMode=null;
      this.addStop(stop);
    },

    clearEndPoint(){
      console.log("method.clearEndPoint");
      this.endPointGraphics=[];
      this.selectedSchool=null;
    }
  }
};
</script>
<style>  
  .viewDiv{
    padding: 0;
    margin: 0;
    height:100%;
    width:100%;
    overflow:hidden
  }
  .buttonsContainer{
    position: absolute;
    top: 10px;
    left:10px;
  }

  .infoContainer{
    position: absolute;
    top: 10px;
    right:10px;
  }

.viewDivComponentsContainer{
  position: relative;	
  height: 100%;    
  pointer-events: none; 
}

.viewDivComponents{
  pointer-events: none;
  height: 100%; 
}

.viewDivComponents >*{
pointer-events: auto;
}


</style>
